import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";
import { CrmDashboardMockup, CrmFloatingCard } from "./CrmMockups";
import { fadeUp } from "./CrmMotion";

const floatCards = [
    { label: "Active Deals", value: "47", trend: "In pipeline" },
    { label: "New Leads", value: "+128", trend: "Today" },
];

export const CrmHeroSection = () => {
    const navigate = useNavigate();

    return (
        <section className="crm-hero">
            <div className="crm-container crm-hero__inner">
                <motion.div
                    className="crm-hero__copy"
                    initial="hidden"
                    animate="visible"
                    variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
                >
                    <motion.h1 className="crm-hero__title" variants={fadeUp}>
                        The Complete{" "}
                        <span className="crm-gradient-text">Customer Growth Platform</span>
                    </motion.h1>
                    <motion.p className="crm-hero__desc" variants={fadeUp}>
                        HonestiIQ gives your team one platform to capture leads, nurture relationships,
                        automate workflows, and grow revenue — built for modern businesses.
                    </motion.p>
                    <motion.div className="crm-hero__cta" variants={fadeUp}>
                        <Button className="crm-btn crm-btn--primary" onClick={() => navigate("/contact")}>
                            Request Demo <ArrowRightOutlined />
                        </Button>
                        <Button
                            className="crm-btn crm-btn--ghost"
                            onClick={() => document.getElementById("crm-command")?.scrollIntoView({ behavior: "smooth" })}
                        >
                            Explore Features
                        </Button>
                    </motion.div>
                </motion.div>

                <div className="crm-hero__showcase">
                    <motion.div
                        className="crm-hero__dashboard"
                        initial={{ opacity: 0, y: 32, scale: 0.96 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <CrmDashboardMockup variant="leads" />
                    </motion.div>
                    {floatCards.map((card, i) => (
                        <CrmFloatingCard key={card.label} {...card} className={`crm-float--${i}`} delay={0.3 + i * 0.15} />
                    ))}
                </div>
            </div>
        </section>
    );
};
